<template>
  <v-dialog :value="true" hide-overlay persistent max-width="400">
    <v-card color="primary" dark>
      <v-card-text class="text-subtitle-1">
        من فضلك انتظر ريثما نحاول التعرف عليك
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
};
</script>

<style>
</style>